/**
 * @generated SignedSource<<1a1d97ee6d6f4363b0405b8e685ad60b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type ClassesFilterInput = {
  haveAtLeastOneStudent?: boolean | null | undefined;
  isActive: ActiveRecords;
  siteIds?: ReadonlyArray<string> | null | undefined;
  siteIsActive: ActiveRecords;
};
export type ClassesGetByTeacherIdOnlyClassesQuery$variables = {
  filter?: ClassesFilterInput | null | undefined;
  skip?: boolean | null | undefined;
  teacherId: string;
};
export type ClassesGetByTeacherIdOnlyClassesQuery$data = {
  readonly classesByTeacherId?: ReadonlyArray<{
    readonly gradeLevels: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string;
    readonly isActive: boolean;
    readonly name: string | null | undefined;
    readonly owner: {
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
    } | null | undefined;
    readonly section: string | null | undefined;
    readonly site: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly students: ReadonlyArray<{
      readonly id: string;
      readonly publicUserId: string | null | undefined;
    } | null | undefined> | null | undefined;
  }>;
};
export type ClassesGetByTeacherIdOnlyClassesQuery = {
  response: ClassesGetByTeacherIdOnlyClassesQuery$data;
  variables: ClassesGetByTeacherIdOnlyClassesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teacherId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "classesFilterInput",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "teacherId",
            "variableName": "teacherId"
          }
        ],
        "concreteType": "ClassNode",
        "kind": "LinkedField",
        "name": "classesByTeacherId",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "section",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SiteNode",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GradeLevelNode",
            "kind": "LinkedField",
            "name": "gradeLevels",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Student",
            "kind": "LinkedField",
            "name": "students",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicUserId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesGetByTeacherIdOnlyClassesQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ClassesGetByTeacherIdOnlyClassesQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "d12b604c6181eb5e8cdd89d8d9fa3c03",
    "id": null,
    "metadata": {},
    "name": "ClassesGetByTeacherIdOnlyClassesQuery",
    "operationKind": "query",
    "text": "query ClassesGetByTeacherIdOnlyClassesQuery(\n  $filter: ClassesFilterInput\n  $teacherId: ID!\n  $skip: Boolean = false\n) {\n  classesByTeacherId(classesFilterInput: $filter, teacherId: $teacherId) @skip(if: $skip) {\n    id\n    name\n    section\n    site {\n      id\n      name\n    }\n    gradeLevels {\n      name\n      id\n    }\n    isActive\n    owner {\n      id\n      firstName\n      lastName\n    }\n    students {\n      id\n      publicUserId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec4697db26fc69105b600fc8a2729459";

export default node;
